import React, { useEffect, useState } from 'react';

import HotBrand from '@/common/icons/HotBrand.svg';
import { LoadingProvider } from '@/common/contexts/loading-context';
import { UserProvider } from '@/common/contexts/user-context';
import { Notification } from '@/components/notification';
import { Stepper } from '@/components/stepper';
import { DocumentPersonal, FinishFlow, RegisterFaceId } from '@/pages/home/steps';

function HomePage() {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      event.returnValue = '';
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  return (
    <div className="container mx-auto h-screen items-center">
      <header className="flex h-8 items-center justify-center py-6">
        <img src={HotBrand} alt="Hotmart" />
      </header>
      <main className="mx-auto max-w-2xl p-4">
        <UserProvider>
          <LoadingProvider>
            <Notification>
              <Stepper active={active} onStepClick={setActive}>
                <Stepper.Step>
                  <RegisterFaceId />
                </Stepper.Step>
                <Stepper.Step>
                  <DocumentPersonal />
                </Stepper.Step>
                <Stepper.Completed className="p-4">
                  <FinishFlow />
                </Stepper.Completed>
              </Stepper>
            </Notification>
          </LoadingProvider>
        </UserProvider>
      </main>
    </div>
  );
}

export default HomePage;
